import { Component, OnInit, OnDestroy, ViewChildren, QueryList, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { skip } from "rxjs/operators";

import { OtherKpModel } from '../../../models/other-kp-model';
import { OtherKpFilter } from '../../../models/other-kp-filter';
import { environment } from '../../../../../../environments/environment';
import { BusOtherKpFilterService } from '../../../services/bus-other-kp-filter.service';
import { CustomerListFilter } from '../../../models/customer-list-filter';
import { OtherKpDetailService } from '../../../services/other-kp-detail.service';
import { LoggingService } from '../../../../../services/logging.service';

const apiServer = environment.apiServer;
const controller = '/otherKp';
declare var $: any;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: 'app-other-kp-main-modal-popup-customer',
  templateUrl: './other-kp-main-modal-popup-customer.component.html',
  styleUrls: ['./other-kp-main-modal-popup-customer.component.sass']
})
export class OtherKpPopupCustomersComponent implements OnInit, OnDestroy, AfterViewInit {

  private subs: any[] = [];

  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;
  @ViewChildren('nameInput') nameInputModel: QueryList<any>;

  checkedDistributerMember: number[];

  dt: DataTables.Api;
  modelCustomerFilter: CustomerListFilter = new CustomerListFilter();
  modelAuctionFilter: OtherKpFilter = new OtherKpFilter();
  dtOptionsCustomerMembers: DataTables.Settings = {};
  dataSetCustomers: any;
  regionId: number = null;
  private listStale = true;   
  private currentKp: OtherKpModel = null;

  constructor(private http: HttpClient, private service: OtherKpDetailService, private bus: BusOtherKpFilterService, private loggingService: LoggingService, private cd: ChangeDetectorRef) {
    this.checkedDistributerMember = [];
  }

  ngOnInit() {
    const that = this;

    $('#modalOtherKpPopupCustomer').off('show.bs.modal shown.bs.modal hidden.bs.modal')
      .on('show.bs.modal', function () {
        $('#modalAuctionDetail').css('z-index', 1030);
        $('#modalOtherKpDetail').css('z-index', 1040);
      })
      .on('shown.bs.modal', function () {
        $('#modalOtherKpPopupCustomer').css('z-index', 1070);
        $('.modal-backdrop:last').css('z-index', 1065);
        
        if (that.listStale) {
          that.listStale = false;
          that.loadList();
        }
      })
      .on('hidden.bs.modal', function () {
        $('#modalAuctionDetail').css('z-index', 1041);
        $('#modalOtherKpDetail').css('z-index', 1060);
      });

    this.subs.push(
      this.bus.currentClearModalFilter$
        .pipe(skip(1))  // При инициализации фильтр уже очищен
        .subscribe(key => {
          if (key === 'customer') {
            this.nameInputModel.forEach(function (item) {
              item.nativeElement.checked = false;
            });
            this.checkedDistributerMember = [];
          }
        })
    );

    this.subs.push(that.service.otherKp$.subscribe(otherKp => {
      that.currentKp = otherKp;
      that.listStale = true;
    }));

    this.subs.push(this.bus.currentClearSearchModalFields$.subscribe(key => {
      if (key === 'customerMemberName') {
        console.log(key);
        this.modelCustomerFilter.name = null;
        this.onFieldChange();
      }
    }));

    this.subs.push(that.service.triggerUpdateListsObserver$.subscribe(() => {
      that.listStale = true;
    }));
    
    this.dtOptionsCustomerMembers = {
      pagingType: 'full_numbers',
      pageLength: 100,
      serverSide: true,
      processing: true,
      autoWidth: false,
      dom: 'tip',
      order: [1],
      deferLoading: 0,
      language: {
        emptyTable: 'Нет данных',
        info: 'Отображено с _START_ по _END_ из _TOTAL_ записей',
        infoEmpty: 'Отображено с 0 по 0 из 0 записей',
        infoFiltered: '(отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Показывать по _MENU_ записей',
        loadingRecords: 'Загрузка ...',
        processing: 'Обработка ...',
        search: 'Поиск:',
        zeroRecords: '',
        paginate: {
          first: 'Первая',
          last: 'Последняя',
          next: 'След.',
          previous: 'Пред.'
        },
        aria: {
          sortAscending: ': activate to sort column ascending',
          sortDescending: ': activate to sort column descending'
        }
      },
      ajax: (dataTablesParameters: any, callback) => {
                
        dataTablesParameters.search = this.modelCustomerFilter.name;
        dataTablesParameters.regionId = this.regionId
        
        that.http.post<DataTablesResponse>(`${apiServer + controller}/customersList`, dataTablesParameters, {})
          .subscribe(resp => {
            that.dataSetCustomers = [{ name: "Другое", id: null }].concat(resp.data);
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
            that.cd.detectChanges();
          });
      },
      columns: [
        { orderable: false },
        { data: 'distrName', name: 'distrName' },
      ]
    };

  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  private loadList() {
    const regionName = this.currentKp ? this.currentKp.regionName : null;

    this.http.post<DataTablesResponse>(`${apiServer}/otherKp/regionsList`, {}, {}).subscribe(regions => {
      this.regionId = regions.data.find(el => el.name == regionName)?.regionId;
      this.dt.ajax.reload();
    });
  }

  onFieldChange() {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.OtherKpPopupCustomersComponent.onFieldChange', null, 'Field change started');
      this.dt.ajax.reload();
      this.loggingService.logFinish(_xid, 'App.Components.OtherKpPopupCustomersComponent.onFieldChange', null, 'Field change completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.OtherKpPopupCustomersComponent.onFieldChange', _error, null, 'Field change failed');
      throw _error;
    }
  }
  
  onSelectedRowMember(event, item) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.OtherKpPopupCustomersComponent.onSelectedRowMember', null, 'Row selection started');
      this.service.changeCustomer(item.name, item.customerId);
      this.loggingService.logFinish(_xid, 'App.Components.OtherKpPopupCustomersComponent.onSelectedRowMember', null, 'Row selection completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.OtherKpPopupCustomersComponent.onSelectedRowMember', _error, null, 'Row selection failed');
      throw _error;
    }
  }

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      this.dt = dtInstance;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/other-kp/component/other-kp-detail/other-kp-main-modal-popup-customer/other-kp-main-modal-popup-customer.component.ts